import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';

import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';

import { Observable, Subscription } from 'rxjs';

import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import * as moment from 'moment-timezone';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, AbstractControl } from '@angular/forms';


import { EntranceExitEvent } from '../firestore-models/entrance-exit-event';
import { EntranceExitTransitDaily } from '../firestore-models/entrance-exit-transit-daily';
import { TransitCount } from '../firestore-models/transit-count';
import { Exhibit } from '../firestore-models/exhibit';
import { ProjectLanguage } from '../firestore-models/project-language';
 
import { ConfigurationService } from '../configuration.service';
import { AppConst } from '../app-const';

import { SelectEntranceExitTransitDailyDialogComponent } from './select-entrance-exit-transit-daily-dialog/select-entrance-exit-transit-daily-dialog.component';
import { EntranceExitTransitDailyDialogComponent } from './entrance-exit-transit-daily-dialog/entrance-exit-transit-daily-dialog.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-entrance-exit-transit-daily',
  templateUrl: './entrance-exit-transit-daily.component.html',
  styleUrls: ['./entrance-exit-transit-daily.component.css'],
  standalone: false,
})
export class EntranceExitTransitDailyComponent implements OnInit, OnDestroy {

  // コレクション
  private entranceExitEventsCollection!: AngularFirestoreCollection<EntranceExitEvent>;
  entranceExitEventsObservable!: Observable<EntranceExitEvent[]>;
  entranceExitEventsSubscribe!: Subscription;
  private entranceExitTransitDailiesCollection!: AngularFirestoreCollection<EntranceExitTransitDaily>;
  entranceExitTransitDailiesObservable!: Observable<EntranceExitTransitDaily[]>;
  entranceExitTransitDailiesSubscribe!: Subscription;
  private exhibitsCollection!: AngularFirestoreCollection<Exhibit>;
  exhibitsObservable!: Observable<Exhibit[]>;
  exhibitsSubscribe!: Subscription;
  exhibits: Exhibit[] = [];

  //各入退場管理日次入退場状況に紐付くプロジェクトID
  projectId: string;
  //各入退場管理日次入退場状況に紐付くプロジェクトの言語情報
  projectLanguages!: Array<ProjectLanguage>;

  //入退場管理日次入退場状況テーブル
  // displayedColumns: string[] = ['position', 'view', 'open_period', 'entry_period', 'date', 'entrance', 'exit', 'exhibit', 'preview'];
  displayedColumns: string[] = ['position', 'view', 'event_name', 'date', 'entrance', 'exit', 'exhibit', 'preview'];
  dataSource = new MatTableDataSource<EntranceExitTransitDaily>();
  selection = new SelectionModel<EntranceExitTransitDaily>(true, []);

  protected ATTR_SEARCH_WORD_PREFIX: string = 'reservationFacilityAttributes';

  attrCollectionName = AppConst.FIRESTORE_RESERVATION_FACILITY_ATTR;

  entranceExitEvents!: Array<EntranceExitEvent>;

  searchFilter: any = {};

  uploadedFilesCollectionName = AppConst.FIRESTORE_UPLOADED_FILES;

  searchParameter = {
    entrance_exit_event_id: null,
    start_date: null,
    end_date: null,
    limit: 15,
    index: 0,
    doc: null,
    prev_doc: null,
    next_doc: null,
    next: true,
  } as any;
  isProcessing = false;

  editForm: UntypedFormGroup;
  get pagesize(): AbstractControl { return this.editForm.get('pagesize')!; }


  // @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;


  constructor(
    public dialog: MatDialog,
    private angularFirestore: AngularFirestore,
    private configurationService: ConfigurationService,
    private formBuilder: UntypedFormBuilder,
    private translate: TranslateService
  ) {
    this.projectId = this.configurationService.getProjectId();
    moment.tz.setDefault('Asia/Tokyo');

    this.editForm = this.formBuilder.group({
      pagesize  : new UntypedFormControl({value: '15',  disabled: false}, []),
    });

  }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    // this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.setCustomFilter();
    // 入退場管理イベント取得
    this.entranceExitEventsCollection = this.angularFirestore.collection<EntranceExitEvent>(
      AppConst.FIRESTORE_ENTRANCE_EXIT_EVENTS, ref => ref.where('project_id', '==', this.projectId));
    this.entranceExitEventsObservable = this.entranceExitEventsCollection.valueChanges({ idField: 'id' });
    this.entranceExitEventsSubscribe = this.entranceExitEventsObservable.subscribe(entranceExitEvents => {
      this.entranceExitEvents = entranceExitEvents.sort((a, b) => {
        if (a.open_start_date.seconds > b.open_start_date.seconds ) {
          return -1;
        }
        if (a.open_start_date.seconds < b.open_start_date.seconds ) {
          return 1;
        }
        return 0;
      });

      // 日次入退場状況取得
      this.getTransits();
    });

    // 展示情報取得
    this.exhibitsCollection = this.angularFirestore.collection<Exhibit>(
      AppConst.FIRESTORE_EXHIBITS, ref => ref.where('project_id', '==', this.projectId));
    this.exhibitsObservable = this.exhibitsCollection.valueChanges({ idField: 'id' });
    this.exhibitsSubscribe = this.exhibitsObservable.subscribe(exhibits => {
      this.exhibits = exhibits;
    });

  }

  ngOnDestroy(): void {
    this.entranceExitEventsSubscribe.unsubscribe();
    this.entranceExitTransitDailiesSubscribe.unsubscribe();
    this.exhibitsSubscribe.unsubscribe();
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
    this.selection.clear() :
    this.dataSource.data.forEach(row => this.selection.select(row));
  }

  checkboxLabel(row?: EntranceExitTransitDaily): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'}`;
  }


  openTransitDialog(daily: EntranceExitTransitDaily) : void {
    let curEvent = null;
    for (const event of this.entranceExitEvents) {
      if (event.id === daily.entrance_exit_event_id) {
        curEvent = event;
      }
    }
    const dialogRef = this.dialog.open(EntranceExitTransitDailyDialogComponent, {
      width: '85%',
      disableClose: true,
      data: { daily: daily, event: curEvent, exhibits: this.exhibits }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  sortData(sort: Sort) {
    const data = this.dataSource.data.slice();
    if (!sort.active || sort.direction === '') {
      this.dataSource.data = data;
      return;
    }
    const compare = (a: number | string | boolean, b: number | string | boolean, isAsc: boolean) => {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }

    this.dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'event_name':
          return compare(this.getEventName(a), this.getEventName(b), isAsc);
        case 'open_period':
          return compare(this.getOpenPeriod(a), this.getOpenPeriod(b), isAsc);
        case 'entry_period':
          return compare(this.getEntryPeriod(a), this.getEntryPeriod(b), isAsc);
        case 'date':
          return compare(a.date, b.date, isAsc);
          case 'entrance':
          return compare(this.getTransitCount(a.entrances), this.getTransitCount(b.entrances), isAsc);
        case 'exit':
          return compare(this.getTransitCount(a.exits), this.getTransitCount(b.exits), isAsc);
        case 'exhibit':
          return compare(this.getTransitCount(a.exhibits), this.getTransitCount(b.exhibits), isAsc);
        case 'preview':
          return compare(a.preview, b.preview, isAsc);
        default:
          return 0;
      }
    });
  }

  setCustomFilter() {
    // NOTE: AND検索
    this.dataSource.filterPredicate = (data: any, filter: any) => {
      let matchCount = 0;
      let keys = Object.keys(filter);
      for (const key of keys) {
        if (!filter[key]) {
          // フィルタに値がない場合は全抽出
          matchCount++;
        } else {
          if (data[key].trim().toLowerCase().indexOf(filter[key]) !== -1) {
            matchCount++;
          }
        }
      }
      return (keys.length === matchCount);
    };
  }

  addFilterValue(docs: Array<any>) :Array<any> {
    for (const doc of docs) {
      let filterValue = '';
      let preview = '';
      if (doc.preview === false) {
        preview = this.translate.instant('本番');
      } else if (doc.preview === true) {
        preview = this.translate.instant('プレ');
      }

      filterValue += preview;
      doc['filterValue'] = filterValue;
    }
    return docs;
  }

  applyFilter(event: Event) {
    this.selection.clear();
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchFilter['filterValue'] = filterValue.trim().toLowerCase();
    this.dataSource.filter = this.searchFilter;
  }

  openSearch(): void {
    const dialogRef = this.dialog.open(SelectEntranceExitTransitDailyDialogComponent, {
      width: '640px',
      disableClose: true,
      data: {parameter: this.searchParameter, events: this.entranceExitEvents}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        console.log(result);
        this.searchParameter.entrance_exit_event_id = result.entrance_exit_event_id;
        this.searchParameter.start_date = result.start_date;
        this.searchParameter.end_date = result.end_date;
        this.searchParameter.index = 0;
        this.searchParameter.doc = null;
        this.searchParameter.next = true;
        this.getTransits();
      }
    });
  }

  async getTransits(): Promise<void> {
    if (this.isProcessing) {
      return;
    }

    this.isProcessing = true;    

    if (!!this.entranceExitTransitDailiesSubscribe) {
      this.entranceExitTransitDailiesSubscribe.unsubscribe();
    }
    this.entranceExitTransitDailiesCollection = this.angularFirestore.collection<EntranceExitTransitDaily>(AppConst.FIRESTORE_ENTRANCE_EXIT_TRANSIT_DAILIES, ref => 
    {
      let query: any = ref;
      query = query.where('project_id', '==', this.projectId);
      if (!!this.searchParameter.entrance_exit_event_id) {
        query = query.where('entrance_exit_event_id', '==', this.searchParameter.entrance_exit_event_id);
      }
      if (!!this.searchParameter.start_date && !!this.searchParameter.end_date) { 
        query = query.where('date', '>=', this.searchParameter.start_date);
        query = query.where('date', '<=', this.searchParameter.end_date);
      };
      query = query.orderBy('date', 'desc');
      if (!!this.searchParameter.doc) {
        if (this.searchParameter.next) {
          query = query.startAfter(this.searchParameter.doc);
        } else {
          query = query.endBefore(this.searchParameter.doc);
        }
      }
      if (this.searchParameter.next) {
        query = query.limit(this.searchParameter.limit + 1);
      } else {
        query = query.limitToLast(this.searchParameter.limit + 1);
      }
      return query;
    });


    this.entranceExitTransitDailiesObservable = this.entranceExitTransitDailiesCollection.valueChanges({ idField: 'id' });
    this.entranceExitTransitDailiesSubscribe = this.entranceExitTransitDailiesObservable.subscribe(async dailies => {

      // 次回検索開始位置を保持
      this.searchParameter.next_doc = null;
      if (dailies.length > 0) {
        if (this.searchParameter.next) {
          const subPrev = this.angularFirestore.collection(AppConst.FIRESTORE_ENTRANCE_EXIT_TRANSIT_DAILIES).doc(dailies[0].id).get().subscribe(doc => {
            subPrev.unsubscribe();
            this.searchParameter.prev_doc = doc;
          });
          if (dailies.length > this.searchParameter.limit) {
            const subNext = this.angularFirestore.collection(AppConst.FIRESTORE_ENTRANCE_EXIT_TRANSIT_DAILIES).doc(dailies[this.searchParameter.limit - 1].id).get().subscribe(doc => {
              subNext.unsubscribe();
              this.searchParameter.next_doc = doc;
            });
          }
        } else {
          if (dailies.length > this.searchParameter.limit) {
            const subPrev = this.angularFirestore.collection(AppConst.FIRESTORE_ENTRANCE_EXIT_TRANSIT_DAILIES).doc(dailies[1].id).get().subscribe(doc => {
              subPrev.unsubscribe();
              this.searchParameter.prev_doc = doc;
            });
          } else {
            this.searchParameter.prev_doc = null;
          }
          const subNext = this.angularFirestore.collection(AppConst.FIRESTORE_ENTRANCE_EXIT_TRANSIT_DAILIES).doc(dailies[dailies.length - 1].id).get().subscribe(doc => {
            subNext.unsubscribe();
            this.searchParameter.next_doc = doc;
          });
        }
        dailies = dailies.slice(0, this.searchParameter.limit); 
      } else {
        this.searchParameter.index = 0;
        this.searchParameter.doc = null;
        this.searchParameter.prev_doc = null;
      }
      this.dataSource.data = this.addFilterValue(dailies);

      this.isProcessing = false;    
    });
  
  }

  getEventName(daily: EntranceExitTransitDaily): string {
    let eventName = '';
    for (const event of this.entranceExitEvents) {
      if (daily.entrance_exit_event_id === event.id) {
        eventName = event.names[0].name;
        break;
      }
    }
    return eventName;
  }

  getOpenPeriod(daily: EntranceExitTransitDaily): string {
    let openPeriod = '';
    for (const event of this.entranceExitEvents) {
      if (daily.entrance_exit_event_id === event.id) {
        openPeriod = moment(event.open_start_date.toDate()).format('YYYY/MM/DD') + ' - ' + moment(event.open_end_date.toDate()).format('YYYY/MM/DD');
        break;
      }
    }
    return openPeriod;
  }

  getEntryPeriod(daily: EntranceExitTransitDaily): string {
    let entryPeriod = '';
    for (const event of this.entranceExitEvents) {
      if (daily.entrance_exit_event_id === event.id) {
        entryPeriod = moment(event.entry_start_date.toDate()).format('YYYY/MM/DD') + ' - ' + moment(event.entry_end_date.toDate()).format('YYYY/MM/DD');
        break;
      }
    }
    return entryPeriod;
  }

  getTransitCount(transitCounts: TransitCount[]): number {
    return transitCounts.reduce((sum, transitCount) => {
      return sum + transitCount.count;
    }, 0);
  }

  // ページサイズ変更
  onPageSizeChange(event: any) {
    this.searchParameter.limit = Number(this.pagesize.value)
    this.searchParameter.index = 0;
    this.searchParameter.doc = null;
    this.searchParameter.next = true;
    this.getTransits();
  }

  // 前へ
  onPrevClick() {
    this.searchParameter.index--;
    this.searchParameter.doc = this.searchParameter.prev_doc;
    this.searchParameter.next = false;
    this.getTransits();
  }

  // 次へ
  onNextClick() {
    this.searchParameter.index++;
    this.searchParameter.doc = this.searchParameter.next_doc;
    this.searchParameter.next = true;
    this.getTransits();
  }}
